import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.registration_request').config(routesConfig);

    routesConfig.$inject = ['$stateProvider'];

    /* @ngInject */
    function routesConfig($stateProvider) {
        $stateProvider
            .state('app.registration_request', {
                abstract: true,
                component: 'contentLayout',
            })
            .state('app.registration_request.list', {
                url: '/registration-request/list',
                views: {
                    content: {
                        component: 'kissRegistrationRequestList',
                    },
                },
            })
            .state('app.registration_request.detail', {
                url: '/registration-request/:id/detail',
                resolve: {
                    registrationRequestBo: getRegistrationRequest,
                },
                views: {
                    content: {
                        component: 'registrationRequestDetail',
                    },
                },
            })

            getRegistrationRequest.$inject=['$transition$', 'registrationRequestSvc']
            function getRegistrationRequest($transition$, registrationRequestSvc) {
                return registrationRequestSvc.getRegistrationRequest($transition$.params().id);
            }
    }
})();
